import { render } from "./ButtonFileUpload.vue?vue&type=template&id=07a01e32"
import script from "./ButtonFileUpload.vue?vue&type=script&lang=js"
export * from "./ButtonFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__